import instance from '@apis/instance';
import { BannerResponse, BannerType } from '@models/banner';

class BannerApi {
    static getBanners(bannerType: BannerType): Promise<BannerResponse> {
        return instance.get('/v0/banners', { params: { bannerType } });
    }
}

export default BannerApi;
